// Heal recipe: auth_secret_missing
// Adds both AUTH_SECRET and NEXTAUTH_SECRET placeholders when neither is present.
// Safe: only adds the key, never overwrites an existing value.

export const RECIPE_GAP_ID = 'auth_secret_missing';

export interface EnvRecipeResult {
  changed: boolean;
  output: string;
  canAutoApply: true;
}

export function applyAuthSecretRecipe(source: string): EnvRecipeResult {
  if (/^\s*(AUTH_SECRET|NEXTAUTH_SECRET)\s*=/m.test(source)) {
    return { changed: false, output: source, canAutoApply: true };
  }

  const lines = [
    '# Auth.js / NextAuth session secret (supported for both AUTH_SECRET and NEXTAUTH_SECRET)',
    'AUTH_SECRET=<generate with: openssl rand -base64 32>',
    'NEXTAUTH_SECRET=<generate with: openssl rand -base64 32>',
  ].join('\n');

  const output = source.trimEnd()
    ? `${source.trimEnd()}\n${lines}\n`
    : `${lines}\n`;

  return { changed: true, output, canAutoApply: true };
}
